<script>
import {BRow, BCol, BFormGroup} from 'bootstrap-vue'
import {BusinessRoles} from "@core/components/supply-chain";
export default {
    components: {BRow, BCol, BFormGroup, BusinessRoles},
    props: {
        role: {
            required: true
        },
    },
    data() {
        return {
            br: this.role.businessRoles
        };
    },
    methods: {
        onChange(businessRoles) {
            this.$emit('input', this.role, businessRoles);
        }
    },
    watch: {
        role() {
            this.br = this.role.businessRoles;
        }
    }
}

</script>

<template>
    <b-row>
        <b-col md="4" lg="4" sm="6" class="justify-content-end align-items-center d-flex">
            {{ role.legalRole.title }}
        </b-col>
        <b-col md="8" lg="8" sm="6">
            <BusinessRoles
                :selected="br"
                @change="onChange"
            />
        </b-col>
    </b-row>
</template>
